module.exports = __webpack_public_path__ + "img/carclean.e461233e.png";